<template>
  <div class="cl-inner">

    <!-- 操作 -->
    <div class="person-oper">
      <a-button type="primary" icon="plus" @click="add()">新建</a-button>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="pagination"
      class="c-table"
      @change="handleTableChange"
    >
      <span slot="imgUrl" slot-scope="text,record"><img :src="record.imgUrl" height="30px" alt="缩略图" @click="show(record.imgUrl)" @error="errorLoadImg"/></span>
      <span slot="clickType" slot-scope="text,record">{{clickTypeStr[record.clickType-1]}}</span>
      <span slot="status" slot-scope="text,record">{{statusStr[record.status]}}</span>
      <span slot="action" slot-scope="text,record,index">
        <template>
          <a
            @click="changeStatus(record.id,record.status,index)"
          >{{record.status==0||record.status==2?'上架':'下架'}}</a>
          <a-divider type="vertical" />
          <a @click="edit(record.id)">修改</a>
          <a-divider type="vertical" />
          <a @click="del(record.id)">删除</a>
        </template>
      </span>
    </a-table>
    <a-modal :maskClosable="false" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" @error="errorLoadImg"/>
    </a-modal>
    <banner-form-modal ref="bannerForm"></banner-form-modal>
  </div>
</template>
<script>
import CTable from "../../components/CTable";
import notification from "ant-design-vue/es/notification";
import banner from "../../api/banner";
import BannerFormModal from "../banner/BannerFormModal";

const columns = [
  {
    title: "广告标题",
    dataIndex: "title",
    key: "title"
  },
  {
    title: "缩略图",
    dataIndex: "imgUrl",
    key: "imgUrl",
    scopedSlots: { customRender: "imgUrl" }
  },
  {
    title: "类型",
    dataIndex: "clickType",
    key: "clickType",
    scopedSlots: { customRender: "clickType" }
  },
  // {
  //   title: "展示城市",
  //   dataIndex: "city",
  //   key: "city"
  // },
  // {
  //   title: "展示学校",
  //   dataIndex: "school",
  //   key: "school",
  //   scopedSlots: { customRender: "status" }
  // },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" }
  },
  // {
  //   title: "创建时间",
  //   dataIndex: "gmtCreate",
  //   key: "gmtCreate"
  // },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "bannerList",
  props: ["orgType"],
  data() {
    return {
        previewVisible: false,
        previewImage: '',
        statusStr: ["待上架", "上架中", "已下架", "已删除"],
        clickTypeStr: ["h5页面", "活动", "班级", "资讯"],
        dataSource: [],
        columns,
        loading: false,
        pagination: { 
				showTotal: total => `总共 ${total} 条`, // 显示总数
      },
    };
  },
  components: {
    CTable,BannerFormModal
  },
  methods: {

    show(url){
      this.previewImage=url;
      this.previewVisible=true;
    },
    //活动列表
    getBannerList(params) {
      this.loading = true;
      banner.getBannerList(params).then(res => {
        // console.log('数据：',res)
        this.pagination = res.data.pagination;
        this.dataSource = res.data.list;
        this.loading = false;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      // console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.getBannerList({
        currentPage: pagination.current,
        pageSize: pagination.pageSize
      });
    },
    changeStatus(id, status, index) {
      console.log('id',id)
      if (status == 0 || status == 2) {
        banner.up({ id,status:1}).then(res => {
          this.dataSource[index].status = 1;
          notification.success({
            message: "消息",
            description: "上架成功！"
          });
        });
      }
      if (status == 1) {
        banner.down({ id ,status:2}).then(res => {
          this.dataSource[index].status = 2;
          notification.success({
            message: "消息",
            description: "下架成功！"
          });
        });
      }
    },
    //新增
    add(value) {
      this.$refs.bannerForm.init('add',{ id: -1})
    },
    edit(value) {
      this.$refs.bannerForm.init('edit',{ id: value ? value : -1})
    },
    del(id) {
      let that = this;
      this.$confirm({
        title: "提示",
        content: "您此次操作将会删除此广告，请确认您是否要删除?",
        okText: "是",
        okType: "danger",
        cancelText: "否",
        onOk() {
          banner.del({ id }).then(res => {
            console.log(res);
            notification.success({
              message: "消息",
              description: "删除成功！"
            });
            that.getBannerList({
              currentPage: that.pagination.current
            });
          });
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    }
  },
  created() {
    this.getBannerList({currentPage:1,pageSize:10});
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.person-oper {
  margin: 20px 0px 30px;
}
</style>